export default "__VITE_ASSET__aAtPBzjg__"